const VerifyCode: React.FunctionComponent<{}> = () => {
    return (<>VerifyCode</>)
}
export default VerifyCode